import cn from "classnames";
import { type ComponentPropsWithRef, type ReactNode } from "react";
import s from "./List.module.css";

export interface ListProps<T> extends ComponentPropsWithRef<"ul"> {
  items: T[];
  renderItem: (item: T, index: number) => ReactNode;
  variant?: "horizontal" | "vertical";
}

export default function List<T>(props: ListProps<T>) {
  const { items, renderItem, variant, ...restProps } = props;

  const className = cn(s.list, restProps.className, {
    [s.vertical]: variant === "vertical",
  });

  return (
    <ul {...restProps} className={className}>
      {items.map((item, index) => (
        <li key={index}>{renderItem(item, index)}</li>
      ))}
    </ul>
  );
}
